import Vue from 'vue';

const comboRepository = {
    all: () => Vue.$axios.get(`updates/`)
        .then(({data}) => data),

    run: (type) => Vue.$axios.post(`updates/run/${type}`)
        .then(({data}) => data),
};

export default comboRepository;
